module.exports = __webpack_public_path__ + "img/gamechar_desert_thumb.e5239b27.jpg";